import { render, staticRenderFns } from "./exchange-search-product.vue?vue&type=template&id=22d05ea9&scoped=true"
import script from "./exchange-search-product.vue?vue&type=script&lang=ts"
export * from "./exchange-search-product.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d05ea9",
  null
  
)

export default component.exports